var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ValidationProvider',{ref:"provider",attrs:{"name":_vm.name,"rules":_vm.validationString},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-switch',{attrs:{"true-value":_vm.trueValue,"false-value":_vm.falseValue,"name":_vm.name,"id":_vm.name,"value":_vm.value,"label":_vm.label},on:{"change":_vm.onInput}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }